const { stringComparator } = require('./utils/comparators');

module.exports = stringComparator(
  'contains',
  (param, substr) => param.includes(substr)
);
